import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const forWhom = ['Hispanos en USA que buscan una alternativa REAL de trabajo desde casa por seguridad personal.', 'Padres y madres de familia que necesitan proveer sin ponerse en riesgo cada mañana en la calle.', 'Personas que valoran su privacidad por encima de todo y quieren un negocio basado en resultados, no en fama.', 'Emprendedores que quieren ganar en dólares para protegerse ante cualquier eventualidad futura.'];
const notForWhom = ["Personas que buscan exposición pública o ser 'famosos'.", 'Quienes no tienen la disciplina de dedicarle tiempo a un negocio digital desde su computadora o teléfono.', 'Gente que busca esquemas fuera de la ley; esto es marketing real, profesional y privado.'];
export function ForWhom() {
  return <section className="bg-[#0a0a0a] py-20" data-id="element-52">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-53">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-54">
          {/* For Whom Panel */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#111] border border-[#d4a437]/30 rounded-2xl p-8 md:p-10 shadow-lg" data-id="element-55">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-56">
              <CheckCircle2 className="w-8 h-8 text-[#d4a437]" data-id="element-57" />
              Esto es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-58">
              {forWhom.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-59">
                  <div className="mt-1 min-w-[24px]" data-id="element-60">
                    <CheckCircle2 className="w-6 h-6 text-[#d4a437]" data-id="element-61" />
                  </div>
                  <p className="text-neutral-300 leading-relaxed" data-id="element-62">{item}</p>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For Whom Panel */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#111] border border-red-900/30 rounded-2xl p-8 md:p-10 shadow-lg" data-id="element-63">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-64">
              <XCircle className="w-8 h-8 text-red-500/80" data-id="element-65" />
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-66">
              {notForWhom.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-67">
                  <div className="mt-1 min-w-[24px]" data-id="element-68">
                    <XCircle className="w-6 h-6 text-red-500/60" data-id="element-69" />
                  </div>
                  <p className="text-neutral-400 leading-relaxed" data-id="element-70">{item}</p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}